import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './ConflictStandardTask.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, TablePagination, Button, Dialog, InputBase } from '@material-ui/core';
import { roleStr, defaultPageSize, isRole, ROLES, ADD, VIEW, EDIT } from '../../common/common';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import TaskInfo from './components/TaskInfo';
import AlertDialog from '../Layout/components/AlertDialog';
import Search from '@material-ui/icons/Search'
import { timeFormat } from '../../common/utils';
import Toast from '../Layout/components/Toast';

class ConflictStandardTask extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tasksData: [
                // {
                //     id: 1,
                //     name: 'task name',
                //     desc: 'desccccccccc',
                //     create_time: '20210401',
                //     update_time: '20210403',
                //     principals: [
                //         {
                //             id: 1,
                //             email: '1234@gmail.com',
                //             phone: '13322223333',
                //             first_name: 'zhang',
                //             last_name: 'san'
                //         }
                //     ],
                // }
            ],
            name: '',
            dialogTitle: '',
            dialogData: {},
            dialogState: ADD,
            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,
            open: false,
            showAlert: false,
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCreateTask = this.handleCreateTask.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            tasksData,
            page_index,
            page_size,
            total_items,
            dialogTitle,
            dialogData,
            dialogState,
            open,
            showAlert,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="Conflict of interest check" subtitle="MANAGEMENT"></PageTitle>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleCreateTask}>create a standard task</Button>
                    </div>
                </div>
                <div className="tableTool h">
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search name"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'name')}
                        />
                    </div>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Task Name</TableCell>
                                <TableCell>Task desc</TableCell>
                                <TableCell>Principal</TableCell>
                                <TableCell>created_at</TableCell>
                                <TableCell>updated_at</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tasksData.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.desc}</TableCell>
                                    <TableCell>{row.principals.length}</TableCell>
                                    <TableCell>{timeFormat(row.create_time)}</TableCell>
                                    <TableCell>{timeFormat(row.update_time)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {tasksData.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={tasksData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Dialog maxWidth={false} open={open}>
                    <TaskInfo
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                    ></TaskInfo>
                </Dialog>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this task?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    componentDidMount() {
        this.doGetTasks();
    }
    doGetTasks() {
        const { page_index, page_size, name } = this.state;
        let params = {
            name,
            page_index,
            page_size
        }
        this.getTasks(params);
    }
    handleSearch(e, name) {
        const value = e.target.value;
        this.setState({
            [name]: value,
            page_index: 1
        }, () => {
            this.doGetTasks();
        })
    }
    handleCreateTask() {
        this.openDialog("CREATE A STANDARD TASK", ADD);
    }
    handleView(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        this.openDialog("STANDARD TASK INFO", VIEW);
    }
    handleEdit(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        console.log(obj)
        this.openDialog("EDIT STANDARD TASK", EDIT);
    }
    handleDel(e, obj) {
        this.setState(() => ({
            dialogData: obj,
            showAlert: true
        }))
    }
    handleCreate(name, desc, user_ids) {
        console.log(name, desc, user_ids)
        const { dialogState, dialogData } = this.state;
        if (dialogState === ADD) {
            this.addTask(name, desc, user_ids)
        } else if (dialogState === EDIT) {
            this.putTask(dialogData.id, name, desc, user_ids)
        }
        this.closeDialog();
    }
    handleCancel() {
        this.closeDialog();
    }
    handleAlertYes() {
        const { dialogData } = this.state;
        this.delTask(dialogData.id);
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getTasks();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getTasks();
        });
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    //---------------request---------------
    getTasks(params) {
        instance.get(BASE_URL + roleStr() + '/standard_task', { params }).then((res) => {
            const tasksData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(tasksData)
            this.setState(() => ({
                tasksData,
                page_size,
                total_items
            }));
        })
    }
    addTask(name, desc, user_ids) {
        let params = {
            name,
            desc,
            user_ids
        }
        instance.post(BASE_URL + roleStr() + '/standard_task', params).then((res) => {
            console.log(res.data.data);
            this.doGetTasks();
        })
    }
    putTask(standard_task_id, name, desc, user_ids) {
        let params = {
            name,
            desc,
            user_ids
        }
        instance.put(BASE_URL + roleStr() + `/standard_task/${standard_task_id}`, params).then((res) => {
            console.log(res.data.data);
            this.doGetTasks();
        })
    }
    delTask(standard_task_id) {
        instance.delete(BASE_URL + roleStr() + `/standard_task/${standard_task_id}`).then((res) => {
            console.log("del standard_task", res);
            this.showToast("Successfully deleted standard task", "success");
            this.doGetTasks();
        })
    }
}

export default withRouter(ConflictStandardTask);